import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { MessageCircle } from "lucide-react";
import ChatPanel from "./ChatPanel";
import { useChat } from "./chatStore";
import styles from "./chat.module.scss";

// Sağ-alt launcher kümesi: üstte dönen-gradient AI butonu, altta mesaj FAB'ı.
// Panel AÇIKKEN küme yavaşça kaybolur (modal kendi X'iyle kapanır).
// Sayfa SONUNA gelince küçülüp sola kayar (alt-sağdaki kartları örtmesin),
// yukarı çıkınca eski haline döner — hepsi efektli.
const ChatLauncher = () => {
  const { open, openPanel, openAI, unreadCount } = useChat();
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        const vh = window.innerHeight;
        const sh = document.documentElement.scrollHeight;
        // Belge taşmıyorsa (kısa sayfa) mini'ye geçme.
        setAtBottom(sh > vh + 40 && y + vh >= sh - 28);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  // Launcher body'ye PORTAL'lanır → herhangi bir ata containing-block/clip
  // etkilemez; gerçek viewport-fixed (sahip: page-wrapper içinde sıkışıyordu).
  return (
    <>
      {createPortal(
        <div
          className={`${styles.launcher} ${open ? styles.launcherHidden : ""} ${
            !open && atBottom ? styles.launcherMini : ""
          }`}
          aria-hidden={open}
        >
          <button
            type="button"
            className={styles.aiFab}
            onClick={openAI}
            aria-label="AI ile sohbet"
            title="AI ile sohbet"
          >
            <span className={styles.aiRing} aria-hidden="true" />
            <span className={styles.aiCore}>AI</span>
          </button>
          <button
            type="button"
            className={styles.fab}
            onClick={openPanel}
            aria-label="Mesajları aç"
            title="Mesajlar"
          >
            <MessageCircle size={22} />
            {unreadCount > 0 && <span className={styles.fabBadge}>{unreadCount}</span>}
          </button>
        </div>,
        document.body
      )}
      <ChatPanel />
    </>
  );
};

export default ChatLauncher;
